const boxWrapperStyle = {
  pad: { vertical: 'small' },
}

export default boxWrapperStyle
